
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_MACRO_ACTIVITIES: (state, payload) => state.macroActivities = payload,
}